module.exports = __webpack_public_path__ + "assets/Suspicious.293db465.svg";